import bluesdata from "./raw/blues.json";

export const BluesColorMap = (type) => {
  if (type === "range") {
    return bluesdata;
  }
};
